
import React from "react";
import { Button, Modal, Spinner } from "react-bootstrap";


const ChangeSubscription = ({ show, handleClose,handleSuccess,submitting}) =>{

    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Are you sure? </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to cancel this subscription change? This means the customer’s subscription will revert back to the “Expiring Subscription“.
                </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    No, Close
                </Button>
                <Button variant="primary" onClick={handleSuccess}>
                    {submitting && <Spinner
                        as="span"
                        animation="grow"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />}
                    Yes, Cancel Change
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ChangeSubscription;